import ButtonExportExcel from '../../../../components/ui/ButtonExportExcel'
import { exportExcelAccountUser } from '../../../../service/ExportExcelAccountUser'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../../../../utils/showToast'
import { useParseQuery } from '../../../../hooks/useNav'
export default function ExportExcelAccountUser() {
  const { queryParams } = useParseQuery()
  const pageNumber = parseInt(queryParams?.pageNumber - 1) || 0
  const handleExport = async () => {
    try {
      showLoadingToast('Đang tải về...', toastKey.ACCOUNT.GROUP.EXPORT)
      const res = await exportExcelAccountUser.export({
        ...queryParams,
        pageNumber,
      })
      if (!res.ok || res?.status !== 200)
        showErrorToast('Xuất excel thất bại!', toastKey.ACCOUNT.GROUP.EXPORT)
      const blob = await res.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      const now = new Date()

      const day = String(now.getDate()).padStart(2, '0')
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const year = now.getFullYear()
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')

      const formatted = `${day}${month}${year}${hours}${minutes}${seconds}`
      a.download = `list_account_users_${formatted}.xlsx`
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
      showSuccessToast('Xuất excel thành công!', toastKey.ACCOUNT.GROUP.EXPORT)
    } catch (error) {
      showErrorToast({
        message: 'Xuất excel thất bại!',
        error: error.message,
        toastId: toastKey.ACCOUNT.GROUP.EXPORT,
      })
    }
  }
  return <ButtonExportExcel onClick={handleExport} />
}
